/*
  LAMIXO footer newsletter (21 Oct 2026).
  - Subscribes in the background: the page never changes.
  - Success and error messages appear under the box (styled for the black
    footer in assets/lamixo-layout.css).
  - One signup per browser session: a second attempt shows a message instead
    of sending another request.
  - If Shopify or its network blocks the request (bot check, rate limit),
    the shopper gets a friendly error under the box instead of being sent to
    a captcha page.
  The listener runs in the capture phase and stops the event there, because
  Shopify injects its own form script that would otherwise submit the form
  normally (full page load, possibly to /challenge) in parallel.
*/
(function () {
  var KEY = 'lmxNewsletterDone';
  var MSG = {
    ok: 'You’re subscribed! Check your inbox to confirm your email.',
    again: 'You’ve already subscribed. Check your inbox for the confirmation email.',
    blocked: 'We couldn’t subscribe you right now. Please try again in a few minutes.',
    invalid: 'Please enter a valid email address.'
  };

  function done() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markDone() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

  function show(form, text, ok) {
    var old = form.querySelector('.lmxf-msg');
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'lmxf-msg ' + (ok ? 'lmxf-msg--ok' : 'lmxf-msg--err');
    p.setAttribute('role', ok ? 'status' : 'alert');
    p.textContent = text;
    form.appendChild(p);
  }

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'lmxf-newsletter') return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if (form.dataset.busy) return;

    var input = form.querySelector('input[type="email"]');
    var email = input ? input.value.trim() : '';
    if (!email || (input && input.checkValidity && !input.checkValidity())) {
      show(form, MSG.invalid, false);
      return;
    }
    if (done()) { show(form, MSG.again, false); return; }
    if (!window.fetch || !window.DOMParser) { show(form, MSG.blocked, false); return; }

    form.dataset.busy = '1';
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    fetch(form.getAttribute('action').split('#')[0], {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok || /\/challenge/.test(r.url)) return { blocked: true };
        return r.text().then(function (html) { return { html: html }; });
      })
      .then(function (res) {
        if (res.blocked) { show(form, MSG.blocked, false); return; }
        var doc = new DOMParser().parseFromString(res.html, 'text/html');
        if (doc.querySelector('.cf-turnstile, #challenge-form, iframe[src*="hcaptcha"]')) {
          show(form, MSG.blocked, false); return;
        }
        var err = doc.querySelector('#lmxf-newsletter .lmxf-msg--err');
        if (err) { show(form, err.textContent.trim() || MSG.invalid, false); return; }
        markDone();
        show(form, MSG.ok, true);
        form.reset();
      })
      .catch(function () { show(form, MSG.blocked, false); })
      .finally(function () {
        delete form.dataset.busy;
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  }, true);
})();
